export { ResponsiveLayout, type Props } from './ResponsiveLayout';
